import { getExtensionService } from "@ntconnect/framework/pbx";

export const fetchExtensions = (domain, page, pageSize, search, filter, support = false) =>
  getExtensionService().fetchExtensions(domain, page, pageSize, search, filter, support);

export const fetchExtension = (domain, extension) =>
  getExtensionService().fetchExtension(domain, extension);

export const updateExtension = (domain, extension, params) =>
  getExtensionService().updateExtension(domain, extension, params);

export const deleteExtension = (domain, extension) =>
  getExtensionService().deleteExtension(domain, extension);

export const fetchRegistrations = (domain) =>
  getExtensionService().fetchRegistrations(domain);

export const createExtension = (domain, params) =>
  getExtensionService().createExtension(domain, params);
